module.exports = __webpack_public_path__ + "static/media/armchairs.90ea8c60.png";